<template>
    <div :class="classes" role="status">
        <div class="container">
            <p>{{ text }}</p>
            <v-button v-if="button" :label="button.text" :href="button.link" color="white" size="sm"></v-button>
        </div>

        <button @click="close" class="close">
            <span class="material-symbols-rounded">close</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                default: '1',
                required: false
            },
            text: {
                type: String,
                required: true
            },
            type: {
                type: String,
                default: 'success',
                validator: function (value) {
                    return ['success', 'warning'].indexOf(value) !== -1
                }
            },
            button: {
                type: Object,
                required: false,
                validator: function(value) {
                    return value.hasOwnProperty('text') && 
                        value.text !== '' &&
                        value.hasOwnProperty('link') &&
                        value.link !== '';
                }
            }
        },

        data() {
            return {
                isActive: true
            }
        },

        mounted() {
            var that = this
            
            this.setNotification()

            window.addEventListener('resize', function() {
                that.setNotification()
            })            
        },

        computed: {
            classes() {
                return {
                    'notification': true,
                    [`notification--${this.type}`]: this.type ? true : false,
                    'notification--active': this.isActive,
                }
            }
        },
        methods: {
            close() {
                let d = new Date()
                d.setHours(d.getHours() + 5)
                var expires = 'expires=' + d.toGMTString()

                document.cookie = 'notification-bar-'+this.id+'=true; ' + expires + '; path=/'

                this.isActive = false
                document.querySelector('.main-content').style.paddingTop = '';
                document.querySelector('.site-header').style.top = '';
            },
            setNotification() {
                var notificationHeight = document.querySelector('.notification').getBoundingClientRect().height;
                var headerHeight = document.querySelector('.site-header').getBoundingClientRect().height;

                if(this.isActive) {
                    document.querySelector('.main-content').style.paddingTop = notificationHeight + headerHeight + 'px';
                    document.querySelector('.site-header').style.top = notificationHeight + 'px';
                }
            }
        }
    }
</script>
